import api from '../api/neighborhoodFronts'
import { fetchFilteredNeighborhoods } from './api'
// Actions
export const actionTypes = {
  RECEIVE_NEIGHBORHOODS_BY_ZONE: 'neighborhoodFront/RECEIVE_NEIGHBORHOODS_BY_ZONE',
  START_GET_NEIGHBORHOODS_BY_ZONE: 'neighborhoodFront/START_GET_NEIGHBORHOODS_BY_ZONE',
  RECEIVE_NEIGHBORHOODS_DETAIL: 'neighborhoodFront/RECEIVE_NEIGHBORHOODS_DETAIL',
  RECEIVE_NEIGHBORHOODS: 'neighborhoodFront/RECEIVE_NEIGHBORHOODS',
  RECEIVE_VISIBLE_NEIGHBORHOODS: 'neighborhoodFront/RECEIVE_VISIBLE_NEIGHBORHOODS',
  SET_PLACES: 'neighborhoodFront/SET_PLACES',
  RECEIVE_TOTAL_SALE: 'neighborhoodFront/RECEIVE_TOTAL_SALE',
  RECEIVE_TOTAL_RENT: 'neighborhoodFront/RECEIVE_TOTAL_RENT',
  RECEIVE_TOTAL_N_RENT: 'neighborhoodFront/RECEIVE_TOTAL_N_RENT',
  RECEIVE_TOTAL_N_SALE: 'neighborhoodFront/RECEIVE_TOTAL_N_SALE',
  RESET_PLACES: 'neighborhoodFront/RESET_PLACES'

}

// Action creators

export const loadNeighborsByZone = () => {
  return (dispatch, getStore) => {
    dispatch(startgetNeighborhoodsByZone())
    let params = dispatch(fetchFilteredNeighborhoods())
    api.fetchNeihborhoodsByZone(params)
      .then((data) => dispatch(receiveNeighborhoodsByZone(data)))
  }
}

export const startgetNeighborhoodsByZone = ()  => {
  return {
    type: actionTypes.START_GET_NEIGHBORHOODS_BY_ZONE
  }
}

export const receiveNeighborhoodsByZone = (APIdata)  => {
  return {
    type: actionTypes.RECEIVE_NEIGHBORHOODS_BY_ZONE,
    list: APIdata
  }
}

export const loadVisibles = () => {
  return (dispatch, getStore) => {
    api.fetchVisibleNeihborhoods()
      .then((data) => dispatch(receiveVisibleNeighborhoods(data)))
  }
}

function receiveVisibleNeighborhoods(APIdata) {
  return {
    type: actionTypes.RECEIVE_VISIBLE_NEIGHBORHOODS,
    list: APIdata
  }
}

export const loadNeighborhoodDetails = (id) => {
  return (dispatch, getStore) => {
    api.fetchNeihborhoodsDetail(id)
      .then((data) => dispatch(receiveNeighborhoodsDetail(data)))
  }
}

function receiveNeighborhoodsDetail(APIdata) {
  return {
    type: actionTypes.RECEIVE_NEIGHBORHOODS_DETAIL,
    data: APIdata[0]
  }
}

export const receiveNeighborhoods = (neighborhoods) => {
  return {
    type: actionTypes.RECEIVE_NEIGHBORHOODS,
    neighborhoods
  }
}

export const loadCaracteristics = (id) => {
  return (dispatch, getStore) => {
    api.totalSaleResults()
      .then((data) => dispatch(receiveTotalSale(data)))
    api.totalRentResults()
      .then((data) => dispatch(receiveTotalRent(data)))
    api.totalNeighborhoodRentResults(id)
      .then((data) => dispatch(receiveTotalNeighborhoodRent(data)))
    api.totalNeighborhoodSaleResults(id)
      .then((data) => dispatch(receiveTotalNeighborhoodSale(data)))
  }
}

export const receiveTotalSale = (APIdata) => {
  var total = APIdata.total
  return {
    type: actionTypes.RECEIVE_TOTAL_SALE,
    total
  }
}

export const receiveTotalRent = (APIdata) => {
  var total = APIdata.total
  return {
    type: actionTypes.RECEIVE_TOTAL_RENT,
    total
  }
}

export const receiveTotalNeighborhoodRent = (APIdata) => {
  var total = APIdata.total
  return {
    type: actionTypes.RECEIVE_TOTAL_N_RENT,
    total
  }
}

export const receiveTotalNeighborhoodSale = (APIdata) => {
  var total = APIdata.total
  return {
    type: actionTypes.RECEIVE_TOTAL_N_SALE,
    total
  }
}

export const addPlacesInfo = (places) => {
  return {
    type: actionTypes.SET_PLACES,
    places
  }
}

export const resetPlaces = () => {
  return {
    type: actionTypes.RESET_PLACES
  }
}





// WEBPACK FOOTER //
// ./src/actions/neighborhoodFront.js